// async function getCountryCode() {
//   try {
//     const response = await fetch('https://ipwho.is/');
//     const data = await response.json();
//     console.log(data);
//     const currentURLPath = window.location.pathname;
//     if(data.country_code != 'US' && currentURLPath.includes('/pages/usa')){
//       window.location.replace("/");
//     }
//   } catch (error) {
//     console.error("Failed to fetch location:", error);
//   }
// }

// getCountryCode();


function initMobileDrawer() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const drawer = document.querySelector('.mobile-menu-drawer');
  const close = document.querySelector('.drawer-close');
  const overlay = document.querySelector('.drawer-overlay');

  if (!toggle || !drawer) return;

  if (toggle.classList.contains('is-init')) return;
  toggle.classList.add('is-init');

  toggle.addEventListener('click', () => {
    drawer.classList.add('active');
    document.body.classList.add('menu-open');
  });

  const closeDrawer = () => {
    drawer.classList.remove('active');
    document.body.classList.remove('menu-open');
  };

  if (close) close.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
}

function initSmoothScroll() {
  document.querySelectorAll('.scroll-link').forEach(link => {

    if (link.classList.contains('is-init')) return;
    link.classList.add('is-init');

    link.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetEl = document.querySelector(targetId);

      if (!targetEl) return;

      const headerOffset = 150;
      const elementPosition = targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  });
}

/* Initial page load */
document.addEventListener('DOMContentLoaded', function () {
  initMobileDrawer();
  initSmoothScroll();
});

/* Shopify Theme Editor / AJAX reload support */
document.addEventListener('shopify:section:load', function () {
  initMobileDrawer();
  initSmoothScroll();
});


  /*---Testimonials Slider---*/

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-testimonial-slider]').forEach(function(slider){

    const wrapper = slider.closest('.testimonial-slider-wrapper');
    if (!wrapper) return;

    const next = wrapper.querySelector('.testimonial-next');
    const prev = wrapper.querySelector('.testimonial-prev');

    const card = slider.querySelector('.testimonial-card');
    if (!card) return;

    const gap = 24;
    let scrollAmount = card.offsetWidth + gap;

    function updateArrows() {
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

      if (slider.scrollLeft <= 0) {
        prev.classList.add('is-disabled');
      } else {
        prev.classList.remove('is-disabled');
      }

      if (slider.scrollLeft >= maxScrollLeft - 2) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }
    }

    updateArrows();

    next.addEventListener('click', function () {
      if (next.classList.contains('is-disabled')) return;

      slider.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });

    prev.addEventListener('click', function () {
      if (prev.classList.contains('is-disabled')) return;

      slider.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });

    slider.addEventListener('scroll', updateArrows);

    window.addEventListener('resize', function () {
      scrollAmount = slider.querySelector('.testimonial-card').offsetWidth + gap;
      updateArrows();
    });

  });

});


function initBundleIncludes() {

  document.querySelectorAll('.sb-includes').forEach(function (wrapper) {

    if (wrapper.classList.contains('is-init')) return;
    wrapper.classList.add('is-init');

    const ol = wrapper.querySelector('ol');
    if (!ol) return;

    const items = ol.querySelectorAll('li');
    const maxItems = 7;

    if (items.length <= maxItems) return;

    const moreBtn = wrapper.querySelector('.sb-more');
    if (!moreBtn) return;

    const hiddenCount = items.length - maxItems;

    // initial state
    items.forEach((item, index) => {
      if (index >= maxItems) {
        item.style.display = 'none';
      }
    });

    moreBtn.textContent = `+ ${hiddenCount} more items`;
    moreBtn.style.display = 'inline';

    moreBtn.addEventListener('click', function () {

      const isExpanded = wrapper.classList.toggle('is-expanded');

      if (isExpanded) {
        // SHOW ALL
        items.forEach(item => {
          item.style.display = '';
        });
        moreBtn.textContent = 'See less';
      } else {
        // SHOW ONLY FIRST 6
        items.forEach((item, index) => {
          item.style.display = index < maxItems ? '' : 'none';
        });
        moreBtn.textContent = `+ ${hiddenCount} more items`;
      }
    });

  });
}

/* Initial load */
document.addEventListener('DOMContentLoaded', initBundleIncludes);

/* Shopify Theme Editor + AJAX support */
document.addEventListener('shopify:section:load', initBundleIncludes);

document.addEventListener('DOMContentLoaded', function () {
  const videoContainers = document.querySelectorAll('.video-container')
  videoContainers.forEach(function (videoContainer) {
    const btn = videoContainer.querySelector('.play-icon');
    const video = videoContainer.querySelector('video');
    if (!btn || !video) return;
    function toggleVideo() {
      if (video.paused) {
        video.play();
        btn.classList.add('hidden');
        // if (posterImage) {
        //   posterImage.classList.add('hidden');
        // }
      } else {
        video.pause();
        btn.classList.remove('hidden');
        // if (posterImage) {
        //   posterImage.classList.remove('hidden');
        // }
      }
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleVideo();
    });
    video.addEventListener('click', function () {
      toggleVideo();
    });
    video.addEventListener('ended', function () {
      btn.classList.remove('hidden');
    });
  });
});

function initReploEducationVideoVisibilityFix() {
  const reploRoot = document.querySelector('#replo-fullpage-element, [id^="replo-section-"]');
  if (!reploRoot || reploRoot.dataset.reploVideoVisibilityFixInit === 'true') return;

  const hasStudentStoriesHeading = /our student success stories/i.test(reploRoot.textContent || '');
  if (!hasStudentStoriesHeading) return;

  reploRoot.dataset.reploVideoVisibilityFixInit = 'true';

  function findSlideElement(startNode) {
    let node = startNode;
    while (node && node !== reploRoot) {
      const roleDescription = node.getAttribute && node.getAttribute('aria-roledescription');
      const part = node.getAttribute && node.getAttribute('data-replo-part');
      const partId = node.getAttribute && node.getAttribute('data-replo-part-id');
      const repeatedIndex = node.getAttribute && node.getAttribute('data-replo-repeated-index');

      if (
        (roleDescription && /slide/i.test(roleDescription)) ||
        (part && /slide/i.test(part)) ||
        (partId && /slide/i.test(partId)) ||
        repeatedIndex
      ) {
        return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  function forceVideoVisible(video) {
    video.style.opacity = '1';
    video.style.visibility = 'visible';
    video.style.display = 'block';
    video.style.pointerEvents = 'auto';
    video.style.zIndex = '2';

    let ancestor = video.parentElement;
    for (let i = 0; i < 5 && ancestor; i += 1) {
      const computed = window.getComputedStyle(ancestor);
      if (computed.opacity === '0') ancestor.style.opacity = '1';
      if (computed.visibility === 'hidden') ancestor.style.visibility = 'visible';
      ancestor = ancestor.parentElement;
    }
  }

  reploRoot.addEventListener(
    'play',
    function (event) {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;
      forceVideoVisible(video);
    },
    true
  );

  reploRoot.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest('button, [role="button"]');
      if (!trigger) return;

      const label = `${trigger.getAttribute('aria-label') || ''} ${trigger.textContent || ''}`.trim();
      if (!/play/i.test(label)) return;

      const slide = findSlideElement(trigger);
      if (slide && typeof slide.scrollIntoView === 'function') {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      window.setTimeout(function () {
        const targetVideo = slide ? slide.querySelector('video') : reploRoot.querySelector('video');
        if (targetVideo) forceVideoVisible(targetVideo);
      }, 120);
    },
    true
  );
}

document.addEventListener('DOMContentLoaded', initReploEducationVideoVisibilityFix);
document.addEventListener('shopify:section:load', initReploEducationVideoVisibilityFix);




// (function () {
//     // Only run on the US landing page
//     if (window.location.pathname !== "/pages/usa") return;

//     fetch("https://ipwho.is/")
//         .then(response => response.json())
//         .then(data => {
//             if (data.country_code !== "US") {
//                 window.location.replace("/");
//             }
//         })
//         .catch(() => {
//             window.location.replace("/");
//         });
// })();


// async function getCountryCode() {
//   try {
//     const response = await fetch('https://ipapi.co/json/');
//     const data = await response.json();
//     console.log(data.country);
//     const currentURLPath = window.location.pathname;
//     if(data.country != 'US' && currentURLPath.includes('/pages/usa')){
//       window.location.href = window.location.host;
//     }
//   } catch (error) {
//     console.error("Failed to fetch location:", error);
//   }
// }

// getCountryCode();

// async function getCountryCode() {
//   try {
//     const response = await fetch('https://ipwho.is/');
//     const data = await response.json();
//     console.log(data);
//     const currentURLPath = window.location.pathname;
//     if(data.country_code != 'US' && currentURLPath.includes('/pages/usa')){
//       window.location.replace("/");
//     }
//   } catch (error) {
//     console.error("Failed to fetch location:", error);
//   }
// }

// getCountryCode();
